var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTerminalSolid = function SvgTerminalSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5v22h24V5Zm2 2h20v2H6Zm0 4h20v14H6Zm5.219 2.781L9.78 15.22 12.562 18l-2.78 2.781 1.437 1.438 3.5-3.5.687-.719-.687-.719ZM16 20v2h6v-2Z"
  })));
};
export default SvgTerminalSolid;